import React, { Component } from "react";
import { Redirect } from 'react-router';
import PropTypes from "prop-types";
import Version from "version";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';


// @material-ui/icons
import Mobile from "@material-ui/icons/PhoneIphone";
import LockOutline from "@material-ui/icons/Lock";
// core components
//import GridContainer from "components/Grid/GridContainer";
//import GridItem from "components/Grid/GridItem";
import Grid from '@material-ui/core/Grid';
import Button from "components/CustomButtons/Button";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardFooter from "components/Card/CardFooter";
import Footer from "components/Footer/Footer";
import Snackbar from "components/Snackbar/Snackbar";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import { Offline, Online } from "react-detect-offline";
import ReactGA from 'react-ga';
import LinearProgress from '@material-ui/core/LinearProgress';

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

//Images
import Logo from "assets/img/Logo.png";
import Board from "assets/img/chalkboard_empty.svg";
//import bgImage from "assets/img/background.jpg";
//Authorization
import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const styles = theme => ({
    ...loginPageStyle,
});

export class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.vm = dotnetify.react.connect("Login", this,
            { headers: { ClientVersion: Version.getVersion() } }
        );
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);  
        this.usernameInput = React.createRef();
        this.passwordInput = React.createRef();
        window.sessionStorage.OverviewIndex = 0;
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            password: '',
            dialogDisabled: false,
            snackbarOpen: false,
            snackbarMessage: '',
            rememberMe: false,
            rememberMeChecked: false,
            loading: false,
            redirect: false,
            usernameErrorText: '',
            passwordErrorText: '',
            username: '',
        };
    }
    componentDidMount() {
        const data = 'Client: ' + Version.getVersion();
        ReactGA.event({
            category: 'Version',
            action: data
        });
        fetch('/api/security/clientinfo')
            .then(response => response.json())
            .then(res => {
                if (res.version !== Version.getVersion()) {
                    this.setState({ Upgrade: true });
                    this.setState({ cardAnimaton: "" });
                    setTimeout(
                        function () {
                            if (window.selfcareRegistration && window.selfcareRegistration.waiting) {
                                window.selfcareRegistration.waiting.postMessage('skipWaiting');
                                if (window.sessionStorage.UpgradeRedirect) {
                                    window.sessionStorage.UpgradeRedirect = false;
                                    window.location.reload(true);
                                } else {
                                    window.sessionStorage.UpgradeRedirect = true;
                                    window.location.href = "https://bounceback.azurewebsites.net/index.html";
                                }
                            } else {
                                if (window.sessionStorage.UpgradeRedirect) {
                                    window.sessionStorage.UpgradeRedirect = false;
                                    window.location.reload(true);
                                } else {
                                    window.sessionStorage.UpgradeRedirect = true;
                                    window.location.href = "https://bounceback.azurewebsites.net/index.html";
                                }
                            }
                        },
                        10000
                    );
                }
                else
                    this.init();
            });
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
    //Version checker
        if (nextState.ServerVersion && !this.state.ServerVersion) {
                const data = 'Client: ' + Version.getVersion() + " Server: " + nextState.ServerVersion;
                ReactGA.event({
                    category: 'Version',
                    action: data
                });
        }
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            setTimeout(
                function () {
                    //this.setState({ disabledAnimation: "" });
                },
                100
            );
        }
    }
    componentDidUpdate() {
        if (this.state.focusObj) {
            this.state.focusObj.focus();
            setTimeout(
                function () {
                    this.setState({ focusObj: null });
                }.bind(this),
                100
            );
        }
    }
    componentWillUnmount() {
        this.vm.$destroy();
        window.updateAvailable = undefined;
        try {
            delete window.updateAvailable;
        } catch (e)
        {
            //
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.Hidden) {
            return false;
        }
        return true;
    }

    init = () => {
        this.setState({ Upgrade: false });

        if (this.checkCRMLogin()) {
            return;
        }
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
        this.checkAutoLogin();
        this.initCheck();
    }
    checkCRMLogin = () => {
        var ticket = this.getParameterByName("ticket");
        if(!ticket)
            return false;
        //window.updateAvailable = () => {
        //    window.location.reload(true);
        //};

        const { onAuthenticated } = this.props;

        this.setState({ error: null, dialogDisabled: true, loading: true });

        auth.signIn("ticket:" + ticket, 'password')
            .then(_ => {
                this.setState({ loading: false });
                ReactGA.event({
                    category: 'Navigation',
                    action: 'Login CRM',
                });
                onAuthenticated();
            })
            .catch(error => {
                this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                this.shake();
                this.setState({ dialogDisabled: false });
                this.setState({ loading: false });
                this.setState({ focusObj: this.usernameInput.current });
                this.setState({ rememberMeChecked: false });
                this.setState({ rememberMe: false });
            });
        return true;
    }
    checkAutoLogin = () => {
        if (this.hasLocalStorage() && window.localStorage.chRememberMe && this.getParameterByName('autologin') === "1") {
            this.setState({ Hidden: true });
            //window.updateAvailable = () => {
            //    window.location.reload(true);
            //};
            const { onAuthenticated } = this.props;
            let password = window.localStorage.getItem('chPassword');
            let user = window.localStorage.getItem('chUsername');
            this.dispatchState({
                Validate: { username: user, password: password }
            });
            auth.signIn(user, password)
                .then(_ => {
                    this.setState({ loading: false });
                    ReactGA.event({
                        category: 'Navigation',
                        action: 'Auto login',
                    });
                    onAuthenticated();
                })
                .catch(error => {
                    this.setState({ Hidden: false });
                    this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                    this.shake();
                    this.setState({ dialogDisabled: false });
                    this.setState({ loading: false });
                    this.setState({ rememberMeChecked: false });
                    this.setState({ rememberMe: false });
                    this.setState({ focusObj: this.usernameInput.current });
                });
        }
    }
    getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }
    updateHookup = () => {
    }

    hideAlert = () => {
        this.setState({
            alert: null
        });
    }

    initCheck = () => {
        if (this.hasLocalStorage() && window.localStorage.chRememberMe) {
            this.setState({ username: window.localStorage.getItem('chUsername'), password: window.localStorage.getItem('chPassword'), rememberMe: true, rememberMeChecked: true });
        }
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
        if (name === "rememberMeChecked" && !event.target.checked) {
            window.localStorage.removeItem('chRememberMe');
            window.localStorage.removeItem('chUsername');
            window.localStorage.removeItem('chPassword');
            this.setState({ rememberMe: false, user: '', password: '' });
        }

    }

    hasLocalStorage = function() {
        try {
            window.localStorage.setItem("__test", "data");
            window.localStorage.removeItem("__test");
        } catch (e) {
            return false;
        }
        return true;
    }

    validate = function () {
        if (this.state.username === '') {
            this.setState({ usernameErrorText: this.props.t('selfcare:error.mobilenumberrequired'), focusObj: this.usernameInput.current });
            return false;
        }
        if (!this.isMobileNumber(this.state.username)) {
            this.setState({ usernameErrorText: this.props.t('selfcare:error.mobilenumberinvalid'), focusObj: this.usernameInput.current });
            return false;
        }
        if (this.state.password === '') {
            this.setState({ passwordErrorText: this.props.t('selfcare:error.passwordrequired'), focusObj: this.passwordInput.current});
            return false;
        }
        return true;
    }

    isMobileNumber = function (msisdn) {
        msisdn = msisdn.replace(/\s+/g, '');
        var locale = process.env.REACT_APP_DEFAULTLOCALE;
        switch (locale.toLowerCase()) {
            case "nb-no":
                if (msisdn.length !== 8 && msisdn.length !== 12)
                    return false;
                return true;
            case "sv-se":
                if (msisdn.length !== 10 && msisdn.length !== 14)
                    return false;
                return true;
            default:
                if (msisdn.length !== 8 && msisdn.length !== 12)
                    return false;
                return true;
        }
    }
    navigateTo = url => {
        this.setState({
            toUrl: url,
            redirect: true
        });
    }

    handleLogin = e => {
        if(e)
            e.preventDefault();
        const { onAuthenticated } = this.props;
        let { password } = this.state;
        let user = this.state.username;
        this.dispatchState({
            Validate: { username: user, password: password }
        });
        if (!this.validate()) {
            this.shake();
            return;
        }
            
        this.setState({ error: null, dialogDisabled: true, loading: true });

        auth.signIn(user, password, null, this.state.rememberMeChecked)
            .then(_ => {
                if (this.state.rememberMeChecked && this.hasLocalStorage() && !window.localStorage.chRememberMe) {
                    window.localStorage.setItem('chRememberMe', true);
                    window.localStorage.setItem('chUsername', user);
                    window.localStorage.setItem('chPassword', '');
                }
                this.setState({ loading: false });
                ReactGA.event({
                    category: 'Navigation',
                    action: 'Login',
                });
                onAuthenticated();
            })
            .catch(error => {
                this.setState({ snackbarMessage: error.message, snackbarOpen: true });
                this.shake();
                this.setState({ dialogDisabled: false });
                this.setState({ loading: false });
                this.setState({ focusObj: this.usernameInput.current });
                this.setState({ rememberMeChecked: false });
                this.setState({ rememberMe: false });
            });
    }
    shake = () => {
        this.setState({ cardAnimaton: "cardShake" });
        setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            10000
        );
    }

    render() {
        const { classes } = this.props;
        const { t } = this.props;
        let { password } = this.state;
        const version = Version.getVersion();
        const anim = classes[this.state.cardAnimaton];
        const hideSnackbar = _ => {
        this.setState({ snackbarOpen: false });
        }
        return (<div>
            {this.state.redirect ? (<Redirect to={this.state.toUrl} />) : null}
                <Snackbar open={this.state.snackbarOpen} color="rose" message={this.state.snackbarMessage} place="tc" close={true} closeNotification={hideSnackbar}/>
                <div className={classes.content}>
                    <div className={classes.container}>
                    <Grid container justify="center">
                            <Grid item xs={10}>
                        <Grid container justify="center">
                                <form onSubmit={(e) => this.handleLogin(e)}>
                                    <Card login className={anim} style={{ maxWidth: '350px' }}>
                                        {this.state.Upgrade ?
                                            (
                                                <div style={{ width: '320px' }}>
                                                <CardHeader
                                                    className={`${classes.cardHeader} ${classes.textCenter}`}
                                                    color="rose"
                                                >
                                                    <img src={Logo} width={150} alt="Chilimobil" />
                                                        <h4 className={classes.cardTitle}>{t('selfcare:title.login')}</h4>
                                                    <div style={{ position: 'absolute', right: '5px', bottom: '1px', fontSize: '11px' }}>ver. {version}</div>
                                                </CardHeader>
                                                    <CardBody>
                                                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.newversion') }} />
                                                    <LinearProgress variant="query" />    
                                                </CardBody>
                                                </div>
                                            ) : null
                                        }
                                        {!this.state.Upgrade ?
                                            (<div><CardHeader
                                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                                color="rose"
                                            >
                                                <img src={Logo} width={150} alt="Chilimobil" />
                                                <h4 className={classes.cardTitle}>{t('selfcare:title.login')}</h4>
                                                <div style={{ position: 'absolute', right: '5px', bottom: '1px', fontSize: '11px' }}>{t('selfcare:info.ver')} {version}</div>
                                            </CardHeader>
                                                <CardBody>
                                                    <Offline>
                                                        {t('selfcare:info.offline')}
                                            </Offline>
                                                    <Online>

                                                        <FormControl fullWidth error={this.state.usernameErrorText !== ''} className={classes.margin}>
                                                            <InputLabel
                                                                classes={{
                                                                    root: classes.cssLabel,
                                                                    focused: classes.cssFocused,
                                                                }}
                                                                htmlFor="username"
                                                            >
                                                                {t('selfcare:input.mobilenumber')}
                                            </InputLabel>
                                                            <Input
                                                                classes={{ underline: classes.cssUnderline }}
                                                                id="username"
                                                                onChange={(event) => { this.setState({ usernameErrorText: '', username: event.target.value }); }}
                                                                type="tel"
                                                                inputRef={this.usernameInput}
                                                                autoFocus
                                                                disabled={this.state.rememberMe || this.state.dialogDisabled}
                                                                value={this.state.username}
                                                                color="secondary"
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <Mobile className={classes.inputAdornmentIcon} />
                                                                    </InputAdornment>
                                                                }
                                                            />
                                                            <FormHelperText id="username-error-text">{this.state.usernameErrorText}</FormHelperText>
                                                        </FormControl>
                                                        <FormControl fullWidth error={this.state.passwordErrorText !== ''} className={classes.margin}>
                                                            <InputLabel
                                                                classes={{
                                                                    root: classes.cssLabel,
                                                                    focused: classes.cssFocused,
                                                                }}
                                                                htmlFor="password"
                                                            >
                                                                {t('selfcare:input.password')}
                                            </InputLabel>
                                                            <Input
                                                                classes={{
                                                                    underline: classes.cssUnderline
                                                                }}
                                                                id="password"
                                                                onChange={event => {
                                                                    this.setState({ password: event.target.value, passwordErrorText: '' });
                                                                }}
                                                                type="password"
                                                                inputRef={this.passwordInput}
                                                                disabled={this.state.rememberMe || this.state.dialogDisabled}
                                                                value={password}
                                                                color="secondary"
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <LockOutline
                                                                            className={classes.inputAdornmentIcon}
                                                                        />
                                                                    </InputAdornment>
                                                                }
                                                            />
                                                            <FormHelperText id="password-error-text">{this.state.passwordErrorText}</FormHelperText>
                                                        </FormControl>
                                                        {this.hasLocalStorage() ?
                                                            <FormControlLabel className={classes.switch}
                                                                control={
                                                                    <Switch
                                                                        checked={this.state.rememberMeChecked}
                                                                        onChange={this.handleChange('rememberMeChecked')}
                                                                        value="rememberMe"
                                                                        color="secondary"
                                                                    />
                                                                }
                                                                label={t('selfcare:label.remember')}
                                                                disabled={this.state.dialogDisabled}
                                                            /> : null}
                                                    </Online>
                                                </CardBody>
                                                <CardFooter className={classes.justifyContentCenter}>
                                                    <Online>
                                                        <div className={classes.wrapper}>
                                                            <Button type="submit" variant="contained" color="rose" size="lg" fullWidth disabled={this.state.dialogDisabled}>
                                                                {t('selfcare:button.login')}
                                        </Button>
                                                            {this.state.loading && <CircularProgress size={36} className={classes.buttonProgress} />}
                                                            <Button variant="contained" size="lg" fullWidth onClick={() => { this.navigateTo('/new-password'); }}>
                                                                {t('selfcare:button.register')}
                                            </Button>
                                                        </div>
                                                    </Online>
                                                </CardFooter></div>) : null}
                                    </Card>
                                    <div style={{ maxWidth: '330px', position: 'relative', top: '-440px', padding: '10px', display: this.state.SelfcareDisabled ? 'block' : 'none' }}>
                                    <img src={Board} style={{ maxWidth: '330px' }} alt="" />
                                        <div style={{ position: 'relative', top: '-255px', left: '25px', width: '270px', height: '180px', color: 'white', fontStyle: 'Italic' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700 }} dangerouslySetInnerHTML={{ __html: this.state.SelfcareDisabledTitle }}/>
                                            <div dangerouslySetInnerHTML={{ __html: this.state.SelfcareDisabledMessage }}/>
                                    </div>
                                </div>
                                </form>
                            </Grid>
                        </Grid>
                    </Grid>
               </div>
               <Footer />     
                </div>
           </div>
           
        );
    }
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired,
    onAuthenticated: PropTypes.func
};

export default compose(
    withTranslation(),
    withStyles(styles),
    )(withAITracking(reactPlugin, LoginPage));
